import React from 'react';
import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

const SkeletonBase = styled.div`
  background: linear-gradient(90deg, #eef0f3 0%, #f7f8fa 50%, #eef0f3 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.4s infinite linear;
`;

const Card = styled.div`
  background-color: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

const Image = styled(SkeletonBase)`
  width: 100%;
  aspect-ratio: 1 / 1;
`;

const Body = styled.div`
  padding: 1rem 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const Bar = styled(SkeletonBase)`
  height: ${(p) => p.height || '12px'};
  width: ${(p) => p.width || '100%'};
  border-radius: 6px;
`;

export const ItemSkeletonCard = () => (
  <Card aria-hidden>
    <Image />
    <Body>
      <Bar height="20px" width="80%" />
      <Bar height="24px" width="50%" />
      <Bar height="12px" width="100%" />
      <Bar height="12px" width="70%" />
      <Bar height="36px" width="100%" />
    </Body>
  </Card>
);

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 1rem;
  }
`;

export const ItemSkeletonGrid = ({ count = 8 }) => (
  <Grid aria-busy="true" aria-label="Loading items">
    {Array.from({ length: count }).map((_, i) => (
      <ItemSkeletonCard key={i} />
    ))}
  </Grid>
);

export default ItemSkeletonGrid;
